import React from "react";
import * as Icons from "lucide-react";

export default function EmptyState({ icon = "Inbox", title, description, action }) {
  const Icon = Icons[icon] || Icons.Inbox;
  return (
    <div
      className="flex flex-col items-center justify-center text-center py-14 px-6"
      data-testid="empty-state"
    >
      <span className="h-12 w-12 rounded-icon bg-inputbg border border-line-strong flex items-center justify-center mb-4">
        <Icon size={20} strokeWidth={1.7} className="text-muted" />
      </span>
      <h3 className="text-[14.5px] font-700 text-ink">{title}</h3>
      {description && (
        <p className="text-[12.5px] text-muted mt-1.5 max-w-sm leading-relaxed">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
